import api from '../../api/index';
export default {
  namespaced: true,
  modules   : {
  },
  state: {
    unfavourite_modal: false,
    selected_number  : 10,
    selected_page    : 1,
    tab              : 'accepted',
    search_string    : '',
    types            : ['news', 'events', 'marketing', 'database'],
    events           : [
      {
        id          : 22,
        type        : 'news',
        label       : 'Новости',
        date        : [],
        likes       : 10,
        liked       : false,
        favourite   : false,
        registration: 'processing',
        title       : 'news_title_2.',
        text        : 'Усовершенствован раздел «База знаний» на портале. Теперь можно скачивать материалы прямо на рабочий компьютер, телефон или планшет. Для реагистрации на портале необходимо запросить логин/пароль у своего…',
        article     : {
          link: '',
          text: '«Проведение работ по ликвидации последствий аварийного разлива нефти/нефтепродуктов»',
        },
        image: '/images/news-1.png',
      },
    ],
  },
  getters: {
    events           : ({events}) => events,
    types            : ({types}) => types,
    selected_page    : ({selected_page}) => selected_page,
    unfavourite_modal: ({unfavourite_modal}) => unfavourite_modal,
    selected_number  : ({selected_number}) => selected_number,
    tab              : ({tab}) => tab,
    search_string    : ({search_string}) => search_string,
    events_accepted({events}) {
      return events.filter((item)=> item.registration == 'accepted');
    },
    events_processing({events}) {
      return events.filter((item)=> item.registration == 'processing');
    },
    events_declined({events}) {
      return events.filter((item)=> item.registration == 'declined');
    },
    filtered_by_tab({events, tab}) {
      return events.filter((item)=> item.registration == tab);
    },
    search_by_string: ({search_string}, {filtered_by_tab})=> {
      return filtered_by_tab.filter((x)=> x.title.toLowerCase().includes(search_string.toLowerCase()));
    },
    paginated({}, {selected_number, filtered_by_tab, selected_page, sorting, search_string, search_by_string}) {
      let search_filtered = search_string ? search_by_string : filtered_by_tab;
      return search_filtered;
      // return search_filtered.slice((selected_number*(selected_page-1)), selected_number*selected_page);
    },
  },
  mutations: {
    CLOSE_MODAL(state) {
      state.unfavourite_modal = false;
    },
    OPEN_MODAL(state) {
      if (!state.unfavourite_modal) {
        state.unfavourite_modal = true;
      }
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    SET_ACTIVE_TAB(state, value) {
      state.tab = value;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    CLEAR_PAGES(state) {
      state.selected_page = 1;
    },
    SEARCH_STRING(state, value) {
      state.search_string = value;
      state.selected_page = 1;
    },
    CANCEL_EVENT(state, id) {
      let current_event_idx = state.events.findIndex((item)=>item.id == id);
      let current_event = state.events.find((item)=>item.id == id);
      current_event.registration = 'canceled';
      state.events.splice(current_event_idx, 1);
    },
    SET_MY_EVENTS(state, value) {
      state.events = value;
    },
    ADD_EVENT(state, value) {
      state.events.push(value);
    },
  },
  actions: {
    async get_events({commit, rootGetters}, id) {
      const user    = rootGetters['profile/user/user'];
      try {
        const events = await api.events.get_user_events(user.id);
        events.data.forEach((x)=> x.date = x.date*1000);
        commit('SET_MY_EVENTS', events.data);
      } catch (err) {
        console.error(err);
      }
    },
    show_number({commit, getters}, event) {
      const {filtered_by_type} = getters;
      commit('CLEAR_PAGES');
      commit('SHOW_NUMBER', {array: filtered_by_type, selected: event});
    },
    async cancel_reg({commit}, id) {
      try {
        await api.events.cancel_event(id);
        commit('CANCEL_EVENT', id);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
